import styled from 'styled-components';

export const Container = styled.div<{ zIndex: number; top: number }>`
  position: fixed;
  top: ${({ top }) => `${top}px` || 0};
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${({ zIndex }) => zIndex};
  background: rgba(0, 0, 0, 0.2);
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;
